import { useOutletContext } from 'react-router'
import { RootOutletContext } from '~/root'

const utmFieldAssignments = {
  utm_medium: 'utm_medium',
  utm_source: 'utm_source',
  utm_campaign: 'utm_campaign',
  utm_content__c: 'utm_content',
  utm_keyword__c: ['utm_term', 'utm_keyword'],
  campaign_code: 'campaign_code',
}

export const UtmFields = () => {
  const { tracking } = useOutletContext<RootOutletContext>()
  const trackingMap = new Map(Object.entries(tracking))

  const fieldInputs = Object.entries(utmFieldAssignments).map(
    ([hubspotId, keyOrKeys]) => {
      if (Array.isArray(keyOrKeys)) {
        const values = keyOrKeys
          .map((key) => trackingMap.get(key))
          .filter(Boolean)

        if (values.length > 0) {
          return (
            <input
              key={hubspotId}
              type="hidden"
              name={hubspotId}
              value={values.join(', ')} // or use a different delimiter
            />
          )
        }
        return null
      }

      // Handle single-key case
      return trackingMap.has(keyOrKeys) ? (
        <input
          key={hubspotId}
          type="hidden"
          name={hubspotId}
          value={trackingMap.get(keyOrKeys)}
        />
      ) : null
    },
  )

  return <>{fieldInputs}</>
}
